module.exports = __webpack_public_path__ + "static/img/11.26077a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/11.png
// module id = WhMi
// module chunks = 0